// Video Carousel Section
document.addEventListener("DOMContentLoaded", function () {
  // Initialize all video carousels
  const carousels = document.querySelectorAll(".video-carousel-splide");

  carousels.forEach(function (carouselElement) {
    // Check if already initialized
    if (carouselElement.classList.contains("is-initialized")) {
      return;
    }

    const splide = new Splide(carouselElement, {
      type: "slide",
      perPage: 4,
      perMove: 1,
      gap: "28px",
      pagination: true,
      arrows: true,
      breakpoints: {
        1024: {
          perPage: 3,
          gap: "24px",
        },
        768: {
          perPage: 2,
          gap: "20px",
        },
        640: {
          perPage: 1,
          gap: "20px",
        },
      },
    });

    splide.mount();
  });

  // Video modal functionality
  const modals = document.querySelectorAll(".video-carousel__video-modal");

  modals.forEach(function (modal) {
    const video = modal.querySelector("video");
    const source = video.querySelector("source");
    const closeButton = modal.querySelector(".video-carousel__video-close");

    // Get all play buttons (find the ones associated with this modal's section)
    const sectionId = modal.id.replace("video-modal-", "");
    const playButtons = document.querySelectorAll(
      ".video-carousel__play-button",
    );

    playButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        const videoUrl = this.getAttribute("data-video-url");
        source.src = videoUrl;
        video.load();
        video.play();
        modal.style.display = "flex";
        document.body.style.overflow = "hidden";
      });
    });

    closeButton.addEventListener("click", function () {
      video.pause();
      video.currentTime = 0;
      source.src = "";
      modal.style.display = "none";
      document.body.style.overflow = "";
    });

    // Close modal when clicking outside
    modal.addEventListener("click", function (e) {
      if (e.target === this) {
        video.pause();
        video.currentTime = 0;
        source.src = "";
        this.style.display = "none";
        document.body.style.overflow = "";
      }
    });
  });

  // Testimonials Carousel
  const testimonialCarousels = document.querySelectorAll(
    ".testimonials__splide",
  );
  testimonialCarousels.forEach(function (carouselElement) {
    // Check if already initialized
    if (carouselElement.classList.contains("is-initialized")) {
      return;
    }

    if (typeof Splide !== "undefined") {
      var testimonials = new Splide(carouselElement, {
        type: "loop",
        perPage: 3,
        perMove: 1,
        gap: "2rem",
        pagination: true,
        arrows: true,
        breakpoints: {
          990: {
            perPage: 2,
            gap: "1.5rem",
          },
          749: {
            perPage: 1,
            gap: "1rem",
          },
        },
      });
      testimonials.mount();
    }
  });

  // Product Carousel
  const productCarousels = document.querySelectorAll(
    ".product-carousel__splide",
  );
  productCarousels.forEach(function (carouselElement) {
    // Check if already initialized
    if (carouselElement.classList.contains("is-initialized")) {
      return;
    }

    if (typeof Splide !== "undefined") {
      var carouselId = carouselElement.id;
      var arrowsContainerId = carouselId.replace(
        "product-carousel-",
        "product-carousel-arrows-",
      );
      var arrowsContainer = document.getElementById(arrowsContainerId);

      var carousel = new Splide(carouselElement, {
        type: "loop",
        perPage: 4,
        perMove: 1,
        gap: "1.5rem",
        padding: { right: "5rem" },
        pagination: false,
        arrows: true,
        breakpoints: {
          1400: {
            perPage: 3,
            gap: "1.5rem",
            padding: { right: "4rem" },
          },
          990: {
            perPage: 2,
            gap: "1.5rem",
            padding: { right: "3rem" },
          },
          749: {
            perPage: 1,
            gap: "1rem",
            padding: { right: "15%" },
          },
        },
      });

      // Function to move arrows to custom container
      function moveArrows() {
        var splideArrows = carouselElement.querySelector(".splide__arrows");
        if (
          arrowsContainer &&
          splideArrows &&
          splideArrows.parentNode !== arrowsContainer
        ) {
          arrowsContainer.appendChild(splideArrows);
        }
      }

      // Move arrows after mount
      carousel.on("mounted", moveArrows);

      carousel.mount();
    }
  });

  // Content Carousel
  const contentCarousels = document.querySelectorAll(
    ".content-carousel__splide",
  );
  contentCarousels.forEach(function (carouselElement) {
    // Check if already initialized
    if (carouselElement.classList.contains("is-initialized")) {
      return;
    }

    if (typeof Splide !== "undefined") {
      var carouselType = carouselElement.dataset.type || "slide";
      var showArrows = carouselElement.dataset.arrows !== "false";
      var showPagination = carouselElement.dataset.pagination === "true";

      var carousel = new Splide(carouselElement, {
        type: "loop",
        autoWidth: true,
        perMove: 1,
        gap: "2rem",
        padding: { right: "5rem" },
        pagination: showPagination,
        arrows: showArrows,
        breakpoints: {
          990: {
            gap: "1.5rem",
            padding: { right: "3rem" },
          },
          749: {
            gap: "1rem",
            padding: { right: "15%" },
          },
        },
      });
      carousel.mount();
    }
  });

  // Related Products Mobile Carousel
  const relatedProductsCarousels = document.querySelectorAll(
    ".related-products-splide",
  );
  relatedProductsCarousels.forEach(function (carouselElement) {
    if (carouselElement.classList.contains("is-initialized")) return;
    if (typeof Splide !== "undefined") {
      var carousel = new Splide(carouselElement, {
        type: "slide",
        perPage: 1,
        perMove: 1,
        gap: "1.5rem",

        pagination: false,
        arrows: true,
        mediaQuery: "min",
        breakpoints: {
          750: {
            destroy: true,
          },
        },
      });
      carousel.mount();
    }
  });

  // Remove duplicate BSS-injected link nodes inside related product card information.
  function removeDuplicateRelatedProductLockLinks(root) {
    const scope = root || document;
    const duplicateLinks = scope.querySelectorAll(
      ".related-products .card-information > a.card__content.full-unstyled-link",
    );

    duplicateLinks.forEach(function (link) {
      const hasLockElement = !!link.querySelector(".bss-lock-element");
      const hasCaptionNode = !!link.querySelector(".caption-large.light");
      const plainText = (link.textContent || "").replace(/\s+/g, "");

      if (hasLockElement && hasCaptionNode && plainText.length === 0) {
        link.remove();
      }
    });
  }

  removeDuplicateRelatedProductLockLinks(document);

  const relatedProductsRoot = document.querySelector(
    ".related-products, product-recommendations.related-products",
  );

  if (relatedProductsRoot) {
    const observer = new MutationObserver(function () {
      removeDuplicateRelatedProductLockLinks(relatedProductsRoot);
    });

    observer.observe(relatedProductsRoot, {
      childList: true,
      subtree: true,
    });
  }

  // Outcome Benefits Carousel (mobile only — destroyed at >= 600px)
  const outcomeBenefitsCarousels = document.querySelectorAll(
    ".outcome-benefits__splide",
  );
  outcomeBenefitsCarousels.forEach(function (carouselElement) {
    if (carouselElement.classList.contains("is-initialized")) return;
    if (typeof Splide !== "undefined") {
      var splide = new Splide(carouselElement, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        gap: "1.5rem",
        arrows: true,
        pagination: false,
        mediaQuery: "min",
        breakpoints: {
          600: {
            destroy: true,
          },
        },
      });
      splide.mount();
    }
  });

  // Collection Section Mobile Carousel — Splide on mobile only,
  // destroyed at >= 750px so the desktop grid (slider-component) takes over.
  const collectionMobileSplides = document.querySelectorAll(
    ".collection__mobile-splide",
  );
  collectionMobileSplides.forEach(function (carouselElement) {
    if (carouselElement.classList.contains("is-initialized")) return;
    if (typeof Splide === "undefined") return;

    const colsMobile = parseInt(
      carouselElement.dataset.columnsMobile || "1",
      10,
    );

    const splide = new Splide(carouselElement, {
      mediaQuery: "min",
      type: "loop",
      perPage: 1,
      perMove: 1,
      gap: "1rem",
      pagination: false,
      arrows: true,
      drag: true,
      breakpoints: {
        750: {
          destroy: true,
        },
      },
    });

    splide.mount();
    carouselElement.classList.add("is-initialized");
  });
});
